// extracted by mini-css-extract-plugin
module.exports = {"about":"components-Header-___header__about___3OQB6","about-terms":"components-Header-___header__about-terms___1DmPG","silveragentLogo":"components-Header-___header__silveragentLogo___K6WSe","userMenu":"components-Header-___header__userMenu___mfMD0","headerEl":"components-Header-___header__headerEl___ufCJQ"};
    if(module.hot) {
      // 1752586141300
      var cssReload = require("/builds/SilverAgent/SilverAgent/ui-parent-r2/silveragent-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"build/","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  